import { Button } from "@mui/material";
import { alpha } from "@mui/material/styles";

export const greenGlowOutlineButtonSx = {
  borderRadius: "10px",
  borderWidth: 1,
  borderStyle: "solid",
  borderColor: "success.main",
  px: 1.75,
  py: 0.625,
  minHeight: 34,
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.8125rem",
  letterSpacing: "-0.01em",
  lineHeight: 1.3,
  color: "success.main",
  bgcolor: (t) =>
    t.palette.mode === "dark"
      ? alpha(t.palette.success.main, 0.12)
      : alpha(t.palette.success.main, 0.06),
  boxShadow: (t) => `0 4px 14px ${alpha(t.palette.success.main, 0.28)}`,
  transition: "all 0.18s ease",
  flexShrink: 0,
  "& .MuiButton-startIcon": { mr: 0.75, ml: -0.25 },
  "&:hover": {
    bgcolor: "success.main",
    color: "success.contrastText",
    borderColor: "success.main",
    boxShadow: (t) => `0 8px 22px ${alpha(t.palette.success.main, 0.45)}`,
    transform: "translateY(-1px)",
  },
  "&:active": {
    transform: "translateY(0)",
    boxShadow: (t) => `0 4px 12px ${alpha(t.palette.success.main, 0.32)}`,
  },
  "&.Mui-disabled": {
    opacity: 0.55,
    color: "success.main",
    borderColor: "success.main",
    bgcolor: (t) => alpha(t.palette.success.main, 0.04),
    boxShadow: "none",
  },
};

export default function GreenGlowOutlineButton({
  children,
  startIcon,
  fullWidth = false,
  sx,
  ...props
}) {
  return (
    <Button
      size="small"
      variant="outlined"
      color="success"
      startIcon={startIcon}
      sx={{
        ...greenGlowOutlineButtonSx,
        width: fullWidth ? "100%" : "auto",
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
}
